import React, { useRef } from "react";
import { DataGrid } from "devextreme-react/data-grid";
import ChartCard from "components/common/pyramid/ChartCard";

const TopCashflowEffects = ({ data }) => {
  const dataGridRef = useRef(null);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const formatCurrency = (cellInfo) => {
    return formatter.format(cellInfo.value);
  };

  const columns = [
    {
      dataField: "Isin",
      caption: "ISIN",
      alignment: "left",
    },
    {
      dataField: "SecurityLib",
      caption: "Security Lib",
      alignment: "left",
    },
    {
      dataField: "CashflowEffect",
      caption: "Cashflow Effect",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "AmoGap",
      caption: "Amortization Variation",
      alignment: "right",
      customizeText: formatCurrency,
    },
  ];

  return (
    <ChartCard
      title="Top 10 Cashflow Effects"
      className="pt-0 pb-3 ps-3 pe-3"
      dataGridRef={dataGridRef}
    >
      <DataGrid
        ref={dataGridRef}
        dataSource={data}
        columns={columns}
        showBorders={true}
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        allowColumnReordering={false}
        allowColumnResizing={false}
        columnAutoWidth={true}
        wordWrapEnabled={false}
        hoverStateEnabled={false}
        sorting={{ mode: "none" }}
        headerFilter={{ visible: false }}
      />
    </ChartCard>
  );
};

export default TopCashflowEffects;
